<template>
  <div class="firstpage" v-loading="loading" @click="close()" :style="showLz ? 'background:#00000080' : ''">
<!--    <div class="swiper-box" id="topPoint">-->
<!--      <Firstpage ref="Firstpage" v-bind="$attrs" v-on="$listeners" />-->
<!--    </div>-->
    <!-- 引入svg图 -->
    <div id="topPoint" style="position: relative; top:-5px;">
      <!-- <img v-if="isAndroid" :src="svg1" />
      <object v-if="!isAndroid" type="image/svg+xml" :data="svg1"></object> -->
      <img :src="bgkv" alt="" srcset="">
    </div>
    <!-- <img v-if="isAndroid" :src="svg2" alt="">
    <img v-if="isAndroid" :src="svg3" alt="" srcset="">
    <img v-if="isAndroid" :src="svg4" alt="" srcset=""> -->
    <img :src="bg1" alt="" srcset="">
    <img :src="bg2" alt="" srcset="">
    <img :src="bg3" alt="" srcset="">
    <section id="qyPoint">
<!--       <img :src="svg5" alt="" srcset=""> -->
    </section>
    <img :src="bg4" alt="" srcset="">
    <!-- <object v-if="!isAndroid" type="image/svg+xml" :data="svg2"></object>
      <object v-if="!isAndroid" type="image/svg+xml" :data="svg3"></object>
      <object v-if="!isAndroid" type="image/svg+xml" :data="svg4"></object> -->
<!--    <section id="qyPoint">-->
<!--      &lt;!&ndash; <img :src="svg5" alt="" srcset=""> &ndash;&gt;-->
<!--    </section>-->
    <div style="height: 100px;"></div>

    <!-- <div class="bgmask" v-if="showLz"></div> -->
    <div class="yy-box" style="position: fixed;bottom: 50px;">
      <img width="100" height="100" :src="arrow" alt="" srcset="">
      <div class="yy-box-btn">
        <button @click.stop.prevent="liuzi()">预约品鉴</button>
      </div>
    </div>
    <div class="right-btn-box" style="position: fixed;bottom: 120px;right: 10px;">
      <span @click="gotoPoint('#qyPoint')" ><img :src="qy" alt="" srcset=""></span>
      <!-- 问卷调研 start-->
      <div @click="clickSurvey" class="btn-survey" code-stm="event, PAGEURL, 点击侧边问卷调研" code-ga="event, PAGEURL页面, 点击侧边问卷调研" id="btn-survey">
      </div>
      <div id="survey-popup">
        <div class="survey-popup-content">
          <div class="survey-popup-title">问卷调研</div>
          <div class="survey-popup-text">邀请您进行一个简短的调研<br>您的意见对于我们的改进非常重要</div>
          <div class="survey-popup-btns">
            <div @click="closeSurvey" class="survey-popup-btn survey-popup-btn-cancel " id="survey-popup-btn-cancel">稍后参加</div>
            <div @click="confirmSurvey" class="survey-popup-btn survey-popup-btns-confirm" id="survey-popup-btn-confirm">立即参加</div>
          </div>
        </div>
      </div>
      <!-- 问卷调研 end-->
      <a href="#qyPoint" ><img :src="qy" alt="" srcset=""></a>
      <!-- <a href="#topPoint" :style="!showTopBtn ? 'visibility:hidden':''"><img width="100%" :src="topbtn" alt="" srcset=""></a> -->
      <span @click="gotoPoint('#topPoint')" v-show="showTopBtn"><img width="100%" :src="topbtn" alt="" srcset=""></span>
    </div>

    <div class="my-form-box" @click.stop>
      <div class="form-container" :style="showLz ? '' : 'transform: translateY(390px)'">
        <MyForm :clientPosition="clientPosition" @close="close"></MyForm>
      </div>
    </div>
  </div>
</template>

<script>
import { isPortraitFun, getUrlKey, isAndroid } from "@/utils/utils.js";
import Firstpage from "./Firstpage.vue";
import MyForm from "./My-Form.vue";
import $ from 'jquery'
// import myBMap from "@/utils/myBMap";
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      minip: false,
      loading: true,
      arrow: require("@/assets/images/arrow.svg"),
      svg5: "/assets/~/media/images/vehicle/ev5/adv/bg04.png",
      bgkv: "/assets/~/media/images/vehicle/ev5/adv/bgkv.png",
      bg1: "/assets/~/media/images/vehicle/ev5/adv/bg01.png",
      bg2: "/assets/~/media/images/vehicle/ev5/adv/bg02.png",
      bg3: "/assets/~/media/images/vehicle/ev5/adv/bg03.png",
      bg4: "/assets/~/media/images/vehicle/ev5/adv/bg04.png",
      qy: require("@/assets/images/qy.svg"),
      topbtn: require("@/assets/images/top.svg"),
      // bg4: require("@/assets/images/bg04.jpg"),
      showLz: false,
      point: null,
      isAndroid: isAndroid(),
      showTopBtn: false,
    };
  },
  props: {
    clientPosition: {
      type: Object,
      default: null
    }
  },
  computed: {
    swiperBoxHeight() {
      const imgHeight = 1.3 * window.innerWidth
      console.log(imgHeight + 270 < window.innerHeight);
      if (imgHeight + 270 < window.innerHeight) {
        return (window.innerHeight - 270) + "px"
      } else {
        return imgHeight + "px"
      }
    }
  },
  components: { Firstpage, MyForm },
  mounted: function () {
    setTimeout(() => {
      this.loading = false
    }, 1000);
    window.addEventListener('scroll', this.handleScroll);
    // this.$nextTick(()=>{
    // this.cutLocal()
    // })
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
    //问卷
   let surveyPopup = document.getElementById("survey-popup")
    if (!window.localStorage.getItem("answerv2") && !getCookie("surveyRecordTime")){
      setTimeout(function () {
        surveyPopup.classList.toggle("active")
      }, 15000)
    }
  },
  methods: {
    gotoPoint(contentId){
      document.querySelector(contentId).scrollIntoView(true);
    },
    //问卷start
    getCookie(){
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0) {
            if (new Date().getTime() > Date.parse(c.substring(nameEQ.length, c.indexOf(";")))) {
              return null; // 过期的cookie返回null
            }
            return c.substring(nameEQ.length, c.indexOf(";"));
          }
        }
        return null;
      },
    clickSurvey(){//点击按钮
      let surveyPopup = document.getElementById("survey-popup")
      surveyPopup.classList.toggle("active")
    },
    closeSurvey(){//稍后参加
      let surveyPopup = document.getElementById("survey-popup")
      let expires = ""
      let date = new Date();
      date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
      document.cookie = "surveyRecordTime" + "=" + ("isUserClose" || "") + expires + "; path=/";
      surveyPopup.classList.remove('active')
    },
    confirmSurvey(){//立即参加
      window.location.href = "/activity/2024/06/survey/index.html#/?Individualquestionnairesurvey&questionnaireNo=QTNO1232&dataFrom=官网问卷"
    },

    //问卷end
    // 监听页面滚动事件
    handleScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      this.showTopBtn = scrollTop > 0;
    },
    smoothScroll(event) {
      event.preventDefault();

      const targetId = event.currentTarget.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        const offsetTop = targetElement.offsetTop;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    },
    liuzi() {
      this.showLz = true
    },
    close() {
      this.showLz = false
    }
  },
};
</script>

<style lang="scss" scoped>
.firstpage {
  position: relative;
  // height: 100%;
  // padding-bottom: 230px;
  width: 100%;
  overflow-y: auto;
  user-select: none;
  background-color: #000000;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  object {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .swiper-box {
    width: 100%;
    overflow: hidden;
  }

  .my-form-box {
    width: 100%;
    //
    display: flex;
    align-items: flex-end;
    position: fixed;
    bottom: 0;
    border-radius: 10px 10px 0px 0px;
    z-index: 2;

    .form-container {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      background-color: #fff;
      transition: transform 0.5s;
    }

    .slide-up {
      transform: translateY(390px);
    }

    // padding: 10px 16px 0;
  }

  .bgmask {
    background: #00000080;
    position: fixed;
    top: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
  }
}

.yy-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  img {
    width: 24px;
    margin-bottom: 20px;
    animation: tbmove 0.7s infinite;
    // height: ;
  }

  &-btn {
    width: 80%;

    button {
      width: 100%;
      height: 43px;
      border-radius: 24px;
      background-color: #000000;
      color: #fff;
      border: 1px solid #FFFFFF;
      // background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 1));
    }
  }
}

.right-btn-box{
  display: flex;
  flex-direction: column;

  img{
    margin-top: 10px;
    width: 44px;
    height: 44px;
  }
}
@keyframes tbmove {
  from {
    margin-bottom: 10px;
  }

  to {
    margin-bottom: 20px;
  }
}
/* 调查问卷 start */
.btn-survey {
      // position: fixed;
      // bottom: calc(6vh + 180px);
      // right: 8px;
      z-index: 1001;
      width: 44px;
      height: 44px;
      background: url('https://uat.kia.cn/assets/~/media/images/dyk/sidebar-icon/survey.png') no-repeat;
      background-size: 100% 100%;
      transition: all .3s;
      overflow: hidden;
      cursor: pointer;
    }
  @media (min-width: 768px) {

    #survey-popup {
      position: fixed;
      bottom: calc(6vh + 240px);
      right: 8px;
      z-index: 10000;
      width: calc(0 / 1920 * 100vw);
      height: calc(0 / 1920 * 100vw);
      background-image: url("https://uat.kia.cn/assets/~/media/images/survey/popup.png");
      background-size: 100% 100%;
      /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
      border-radius: 0.8px;
      transform: translate(0, 0) scale(0);
      transition: 1s ease-in-out;

      /* transition: transform 1s ease-in-out; */

    }

    .survey-popup-content {
      height: 100%;
    }

    .survey-popup-title {
      font-family: "KiaSignatureRegular", "方正兰亭", "Helvetica Neue", Helvetica, Arial, sans-serif;
      color: #000000;
      width: 40%;
      height: calc(0 / 1920 * 100vw);
      /* font-family: 'FZLanTingHeiS-B-GB'; */
      font-size: calc(0 / 1920 * 100vw);
      display: flex;
      align-items: flex-end;
      justify-content: center;
      transition: 1s ease-in-out;
    }

    .survey-popup-text {
      font-family: "KiaSignatureRegular", "方正兰亭", "Helvetica Neue", Helvetica, Arial, sans-serif;
      color: #000000;
      height: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: calc(0 / 1920 * 100vw);
      transition: 1s ease-in-out;
    }

    .survey-popup-btns {
      display: flex;
      align-items: center;
      justify-content: space-around;
    }

    .survey-popup-btn {
      /* width: 30%;
            height: 20px; */
      padding: calc(0 / 1920 * 100vw) calc(0 / 1920 * 100vw);
      background: #000;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: 1s ease-in-out;
    }

    #survey-popup.active {
      position: fixed;
      bottom: 50%;
      right: 50%;
      width: calc(500 / 1920 * 100vw);
      height: calc(290 / 1920 * 100vw);
      z-index: 10000;
      transform: translate(50%, 50%) scale(1);


    }

    #survey-popup.active .survey-popup-content {
      height: 100%;


    }

    #survey-popup.active .survey-popup-title {
      height: calc(70 / 1920 * 100vw);
      /* font-family: 'FZLanTingHeiS-B-GB'; */
      font-size: calc(28 / 1920 * 100vw);
    }

    #survey-popup.active .survey-popup-text {
      font-size: calc(22 / 1920 * 100vw);
    }

    #survey-popup.active .survey-popup-btns .survey-popup-btn {
      /* width: 30%;
            height: 20px; */
      padding: calc(10 / 1920 * 100vw) calc(50 / 1920 * 100vw);
    }
  }
  @media (max-width: 768px) {
    // .btn-survey {
    //   background: url('https://uat.kia.cn/assets/~/media/images/dyk/sidebar-icon/survey.png') no-repeat;
    //   background-size: 100% 100%;
    //   bottom: calc(6vh + 120px);
    //   width: 35px;
    //   height: 35px;
    // }
    #survey-popup {
      position: fixed;
      bottom: calc(6vh + 160px);
      right: 8px;
      z-index: 10000;
      width: calc(0 / 375 * 100vw);
      height: calc(0 / 375 * 100vw);
      background-image: url("https://uat.kia.cn/assets/~/media/images/survey/popup.png");
      background-size: 100% 100%;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      border-radius: 0.8px;
      transform: translate(0, 0) scale(0);
      transition: 1s ease-in-out;


    }

    .survey-popup-content {
      height: 100%;


    }

    .survey-popup-title {
      color: #000000;
      width: 40%;
      height: calc(0 / 375 * 100vw);
      /* font-family: 'FZLanTingHeiS-B-GB'; */
      font-size: calc(0 / 375 * 100vw);
      display: flex;
      align-items: flex-end;
      justify-content: center;
      transition: 1s ease-in-out;
    }

    .survey-popup-text {
      color: #000000;
      height: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: calc(0 / 375 * 100vw);
      transition: 1s ease-in-out;
    }

    .survey-popup-btns {
      display: flex;
      align-items: center;
      justify-content: space-around;


    }

    .survey-popup-btn {
      /* width: 30%;
            height: 20px; */
      padding: calc(0 / 375 * 100vw) calc(0 / 375 * 100vw);
      font-size: calc(0 / 375 * 100vw);
      background: #000;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: 1s ease-in-out;
    }

    #survey-popup.active {
      position: fixed;
      bottom: 50%;
      right: 50%;
      width: calc(340 / 375 * 100vw);
      height: calc(197 / 375 * 100vw);
      z-index: 10000;
      transform: translate(50%, 50%) scale(1);


    }

    #survey-popup.active .survey-popup-content {
      height: 100%;


    }

    #survey-popup.active .survey-popup-title {
      height: calc(47 / 375 * 100vw);
      /* font-family: 'FZLanTingHeiS-B-GB'; */
      font-size: calc(18 / 375 * 100vw);
    }

    #survey-popup.active .survey-popup-text {
      font-size: calc(14 / 375 * 100vw);
    }

    #survey-popup.active .survey-popup-btns .survey-popup-btn {
      /* width: 30%;
        height: 20px; */
      padding: calc(7 / 375 * 100vw) calc(40 / 375 * 100vw);
      font-size: calc(14 / 375 * 100vw);
    }
  }
  /* 调查问卷 end */
</style>
